export default __webpack_public_path__ + "static/media/HAN_LI.97b22ab5.png";